import React from 'react';
import classnames from 'classnames';

import './TopicSelector.scss';

class TopicItem extends React.Component {
  render () {
    return (
      <div className={classnames({
        'TopicItem': true,
        'TopicItem--Active': this.props.isActive,
      })} onClick={this.props.onClick}>
        <div className='CheckBox'>
          <input readOnly checked={this.props.isActive} type='checkbox' id={'CheckBox_' + this.props.Topic.name} />
        </div>
        <p className='TopicItem__Name'>{this.props.Topic.name}</p>
      </div>
    );
  }
}

TopicItem.defaultProps = {
  isActive: false,
  onClick: () => {},
};

class CollapsableSection extends React.Component {
  constructor (props, context) {
    super(props, context);

    this.state = {
      visibleState: false
    };
    this.toggleState = this.toggleState.bind(this);
  }

  toggleState () {
    this.setState({
      visibleState: this.state.visibleState === false
    });
  }

  render () {
    return (
      <div className='CollapsableSection'>
        <div className='CollapsableSection__Header' onClick={this.toggleState}>
          <span>{(this.state.visibleState) ? ' - ' : ' + '}</span>
          <h1>{this.props.title}</h1>
        </div>
        <div style={(this.state.visibleState) ? {} : { display:'none' }} className='CollapsableSection__Body'>
          {this.props.children}
        </div>
      </div>
    );
  }
}

CollapsableSection.propTypes = {
  title: React.PropTypes.string.isRequired,
  children: React.PropTypes.node,
};

const TopicTag = (props) => (
  <div className='TopicTag'>
    <p className='TopicTag__Name'>{props.name}</p>
    <a className='TopicTag__Cancel' onClick={props.onClick}>×</a>
  </div>
);

class TopicSelector extends React.Component {
  constructor (props, context) {
    super(props, context);

    console.log(props);

    const TopicsMap = props.Topics.reduce((a, b) => {
      return a.concat(b.topics);
    }, []).reduce((a, b) => {         // Final object is of shape {
      let Val = a;                    //   1: "Topic Name"
      Val[b.id] = b.name;             //   2: "Other Name"
      return Val;                     // }
    }, {});

    this.state = {
      currentVal: props.defaultValue.reduce((sum, value) => {
        let intermitant = sum;
        intermitant[value] = true;
        return intermitant;
      }, {}),
      TopicKeys: TopicsMap
    };

    this.toggleTopic = this.toggleTopic.bind(this);
    this.isActive = this.isActive.bind(this);
    this.propogateChange = this.propogateChange.bind(this);
  }

  toggleTopic (id) {
    return () => {
      let newVal = this.state.currentVal;
      newVal[id] = newVal[id] !== true;

      this.propogateChange(newVal);

      this.setState({
        currentVal: newVal
      });
    };
  }

  isActive (id) {
    if (Object.prototype.hasOwnProperty.call(this.state.currentVal, id)) {
      return this.state.currentVal[id];
    }
    return false;
  }

  propogateChange (ReturnValue) {
    if (this.props.onChange && this.props.name) {
      this.props.onChange({
        type: 'change',
        target: {
          name: this.props.name,
          value: Object.keys(ReturnValue).reduce((sum, value) => {
            if (ReturnValue[value]) {
              return [
                ...sum,
                value
              ];
            }
            return sum;
          }, [])
        }
      });
    }
  }

  render () {
    return (
      <div className='TopicSelector'>
        <div className='TopicSelector__Selected'>
          {Object.keys(this.state.currentVal).map(index => {
            if (this.state.currentVal[index]) {
              return (
                <TopicTag key={index} name={this.state.TopicKeys[index]} onClick={this.toggleTopic(index)} />
              );
            }
            return null;
          })}
        </div>
        {this.props.Topics.map(TopicCategory => (
          <CollapsableSection key={'Cat' + TopicCategory.id} title={TopicCategory.name}>
            {TopicCategory.topics.map(Topic => (
              <TopicItem isActive={this.isActive(Topic.id)} onClick={this.toggleTopic(Topic.id)} Topic={Topic} key={'Item' + Topic.id} />
            ))}
          </CollapsableSection>
        ))}
      </div>
    );
  }
}

TopicSelector.defaultProps = {
  defaultValue: []
};

export default TopicSelector;



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/CoachingPreferences/components/TopicSelector/index.js